import '@repo/ui/globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { ApiClientContext, createWebApiClient } from '@/api/api-client';
import { createSessionHolder } from '@/auth/session-holder';
import { browserSessionStorage, createSessionStorage } from '@/auth/session-storage';
import { SessionProvider } from '@/auth/SessionProvider';
import { systemClock } from '@/lib/clock';

import { App } from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

// The composition root, and the only place the three parts of the session meet:
// where it is kept (`sessionStorage` — the argument is in `session-storage.ts`),
// what holds it, and the real clock. Everything below takes what it needs.
const session = createSessionHolder({
  storage: createSessionStorage(browserSessionStorage()),
  clock: systemClock,
});

// One client for the whole app. It reads the token from the same holder the
// provider renders, and ends that session when the API answers
// `AUTH_SESSION_EXPIRED` — from any request, on any screen.
const apiClient = createWebApiClient(session);

createRoot(container).render(
  <StrictMode>
    {/* BrowserRouter works in both targets because the desktop shell serves
        this bundle over a custom app:// protocol with SPA fallback, rather
        than from file:// where the history API breaks. */}
    <BrowserRouter>
      <ApiClientContext value={apiClient}>
        {/* Inside the router and inside the client: it returns to sign-in when
            a session ends, and signs out through the API. */}
        <SessionProvider holder={session}>
          <App />
        </SessionProvider>
      </ApiClientContext>
    </BrowserRouter>
  </StrictMode>,
);
